var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { class: _vm.mergedClass, style: _vm.mergedStyle }, [
    _c("thead", [
      _c("tr", [
        _c("th", [
          _vm._v(
            _vm._s(_vm.$t("dashboard.activityStatusSumsTable.organization"))
          )
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(
              _vm.$t("dashboard.activityStatusSumsTable.activities.planned")
            )
          )
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(
              _vm.$t("dashboard.activityStatusSumsTable.activities.unplanned")
            )
          )
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(_vm.$t("dashboard.activityStatusSumsTable.activities.open"))
          )
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(
              _vm.$t("dashboard.activityStatusSumsTable.activities.inProgress")
            )
          )
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(
              _vm.$t("dashboard.activityStatusSumsTable.activities.plannedPie")
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm.selectedPath.length > 0
          ? _c("tr", [
              _c("td", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectedPath.pop()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-level-up-alt" }),
                    _vm._v("..\n        ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.entries, function(entry) {
          return _c("tr", [
            _c(
              "td",
              [
                entry.children.length > 0
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectedPath.push(entry)
                          }
                        }
                      },
                      [_vm._v(_vm._s(entry.accountName))]
                    )
                  : [_vm._v(_vm._s(entry.accountName))]
              ],
              2
            ),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.getConsolidated(entry, e => e.sums.planned)))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.getConsolidated(entry, e => e.sums.unplanned)))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.getConsolidated(entry, e => e.sums.open)))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.getConsolidated(entry, e => e.sums.inProgress)))
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "p-0" },
              [
                _c("PieChart", {
                  staticStyle: { height: "3em", width: "3em" },
                  attrs: {
                    planned: _vm.getConsolidated(entry, e => e.sums.planned),
                    unplanned: _vm.getConsolidated(
                      entry,
                      e => e.sums.unplanned
                    ),
                    open: _vm.getConsolidated(entry, e => e.sums.open),
                    "in-progress": _vm.getConsolidated(
                      entry,
                      e => e.sums.inProgress
                    )
                  }
                })
              ],
              1
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }